import { ExternalAuthForm } from "./ExternalAuthForm";

export default {
  ExternalAuthForm,
};
